// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd73575f","389":"49b729e0","453":"f7806de0","455":"591b095b","977":"a1d9d7c2"}[chunkId] + ".chunk.js";
};